/* VaperCore theme — interactions
   Every module is isolated (a failure in one never stops the others) and re-runs
   on theme-editor section reloads. */
(function () {
  'use strict';

  var VC = window.VC || {};
  var R = VC.routes || {};
  var S = VC.strings || {};
  var motion = document.documentElement.classList.contains('motion');
  var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------- helpers ---------- */
  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function on(el, ev, fn, opt) { if (el) el.addEventListener(ev, fn, opt); }
  function safe(name, fn) { try { fn(); } catch (e) { if (window.console) console.warn('[VaperCore] ' + name, e); } }
  function once(el, key) { if (el['_vc' + key]) return false; el['_vc' + key] = true; return true; }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || VC.moneyFormat || '€{{amount_with_comma_separator}}';
    function withDelims(n, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(n) || n == null) return 0;
      n = (n / 100.0).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var m = fmt.match(re);
    switch (m ? m[1] : 'amount') {
      case 'amount': value = withDelims(cents, 2); break;
      case 'amount_no_decimals': value = withDelims(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelims(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelims(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = withDelims(cents, 2, ' ', ','); break;
      default: value = withDelims(cents, 2);
    }
    return fmt.replace(re, value);
  }

  function getJSON(url) {
    return fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }
  function postJSON(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function fetchHTML(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (t) { return new DOMParser().parseFromString(t, 'text/html'); });
  }
  function withParam(url, key, val) {
    var u = new URL(url, window.location.origin);
    u.searchParams.set(key, val);
    return u.pathname + u.search;
  }

  /* ---------- cart count + toast ---------- */
  function setCount(n) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = !n;
      el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
    });
  }
  function refreshCount() {
    return getJSON((R.cart || '/cart') + '.js').then(function (c) { setCount(c.item_count); return c; });
  }
  var toastTimer;
  function toast(name, isError) {
    var t = qs('[data-toast]');
    if (!t) return;
    t.classList.toggle('is-error', !!isError);
    qs('[data-toast-title]', t).textContent = isError ? (S.error || 'Error') : (S.added || 'Added to cart');
    qs('[data-toast-name]', t).textContent = name || '';
    qs('.toast__btn', t).hidden = !!isError;
    t.hidden = false;
    t.style.animation = 'none'; void t.offsetWidth; t.style.animation = '';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.hidden = true; }, 3200);
  }

  /* ---------- scroll reveal ---------- */
  function initReveal(root) {
    if (!motion || !('IntersectionObserver' in window)) return;
    var els = qsa('[data-reveal], .card-rise', root).filter(function (el) { return !el.classList.contains('rv') && !el.closest('.modal'); });
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.92 && r.bottom > 0) { el.classList.add('rv', 'in'); return; }
      if (el.classList.contains('card-rise') && el.parentElement) {
        var idx = Array.prototype.indexOf.call(el.parentElement.children, el);
        el.style.setProperty('--rd', Math.min(idx, 8) * 0.07 + 's');
      }
      el.classList.add('rv');
      io.observe(el);
    });
    /* failsafe: never leave content hidden */
    setTimeout(function () { els.forEach(function (el) { el.classList.add('in'); }); }, 3000);
  }

  /* ---------- 3D tilt + parallax ---------- */
  function initTilt(root) {
    if (!motion || !finePointer) return;
    qsa('[data-tilt]', root).forEach(function (el) {
      if (!once(el, 'tilt')) return;
      var max = parseFloat(el.getAttribute('data-tilt')) || 6;
      var raf;
      on(el, 'pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          el.style.transition = 'transform .12s ease-out';
          el.style.transform = 'perspective(900px) rotateX(' + (-y * max).toFixed(2) + 'deg) rotateY(' + (x * max).toFixed(2) + 'deg) translateY(-6px)';
        });
      });
      on(el, 'pointerleave', function () {
        cancelAnimationFrame(raf);
        el.style.transition = 'transform .6s cubic-bezier(.22,1,.36,1)';
        el.style.transform = '';
      });
    });
  }
  function initParallax(root) {
    if (!motion || !finePointer) return;
    qsa('.hero, .pdp__stage, .banner, .whero', root).forEach(function (zone) {
      if (!once(zone, 'plx')) return;
      on(zone, 'pointermove', function (e) {
        var r = zone.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        qsa('[data-parallax]', zone).forEach(function (el) {
          var d = parseFloat(el.getAttribute('data-parallax')) || 10;
          el.style.transform = 'translate3d(' + (x * d).toFixed(1) + 'px,' + (y * d).toFixed(1) + 'px,0)';
        });
      });
      on(zone, 'pointerleave', function () {
        qsa('[data-parallax]', zone).forEach(function (el) { el.style.transform = ''; });
      });
    });
  }

  /* ---------- header ---------- */
  function initHeader(root) {
    var wrap = qs('[data-header]', root);
    if (!wrap || !once(wrap, 'hdr')) return;
    if (wrap.classList.contains('hdr-wrap--sticky')) {
      var ticking = false;
      on(window, 'scroll', function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () { wrap.classList.toggle('is-stuck', window.scrollY > 30); ticking = false; });
      }, { passive: true });
    }
    /* dropdowns: hover on desktop, tap to open on touch */
    qsa('[data-menu]', wrap).forEach(function (item) {
      var link = qs('.hdr__link', item);
      on(link, 'click', function (e) {
        if (!finePointer && !item.classList.contains('is-open')) {
          e.preventDefault();
          qsa('[data-menu].is-open', wrap).forEach(function (o) { o.classList.remove('is-open'); });
          item.classList.add('is-open');
          link.setAttribute('aria-expanded', 'true');
        }
      });
      on(item, 'mouseenter', function () { link.setAttribute('aria-expanded', 'true'); });
      on(item, 'mouseleave', function () { link.setAttribute('aria-expanded', 'false'); item.classList.remove('is-open'); });
    });
    /* language */
    var lang = qs('[data-lang]', wrap);
    if (lang) {
      var btn = qs('[data-lang-toggle]', lang);
      on(btn, 'click', function (e) {
        e.stopPropagation();
        var open = !lang.classList.contains('is-open');
        lang.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open);
      });
      qsa('.lang__item', lang).forEach(function (b) {
        on(b, 'click', function () {
          try { localStorage.setItem('vc-lang', b.value); } catch (e) {}
        });
      });
    }
    on(document, 'click', function (e) {
      if (lang && !lang.contains(e.target)) { lang.classList.remove('is-open'); qs('[data-lang-toggle]', lang).setAttribute('aria-expanded', 'false'); }
      if (!e.target.closest('[data-menu]')) qsa('[data-menu].is-open', wrap).forEach(function (o) { o.classList.remove('is-open'); });
    });
    on(document, 'keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (lang) lang.classList.remove('is-open');
      qsa('[data-menu].is-open', wrap).forEach(function (o) { o.classList.remove('is-open'); });
    });

    /* search */
    var pop = qs('[data-search]', wrap);
    var openBtn = qs('[data-search-open]', wrap);
    if (pop && openBtn) {
      var input = qs('[data-predictive-input]', pop);
      var results = qs('[data-predictive-results]', pop);
      var close = function () { pop.hidden = true; openBtn.focus(); };
      on(openBtn, 'click', function () { pop.hidden = !pop.hidden; if (!pop.hidden) setTimeout(function () { input.focus(); }, 30); });
      on(qs('[data-search-close]', pop), 'click', close);
      on(pop, 'keydown', function (e) { if (e.key === 'Escape') close(); });
      var timer;
      on(input, 'input', function () {
        clearTimeout(timer);
        var q = input.value.trim();
        if (q.length < 2) { results.innerHTML = ''; return; }
        timer = setTimeout(function () {
          getJSON((R.predictive || '/search/suggest') + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,article,page&resources[limit]=6')
            .then(function (data) {
              var res = (data.resources && data.resources.results) || {};
              var wsTag = VC.wsTag || '';
              var items = (res.products || []).filter(function (p) {
                return !wsTag || !(p.tags || []).some(function (t) { return String(t).toLowerCase() === wsTag; });
              }).map(function (p) {
                var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
                return '<a class="pred__item" href="' + p.url + '"><span class="pred__img">' + (img ? '<img src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy">' : '') + '</span><span><span class="pred__t">' + p.title + '</span><br><span class="pred__p">' + (p.price ? formatMoney(Math.round(parseFloat(p.price) * 100)) : '') + '</span></span></a>';
              });
              (res.articles || []).concat(res.pages || []).slice(0, 3).forEach(function (a) {
                items.push('<a class="pred__item" href="' + a.url + '"><span class="pred__img"></span><span class="pred__t">' + a.title + '</span></a>');
              });
              results.innerHTML = items.length
                ? '<div class="pred">' + items.join('') + '<a class="pred__all" href="' + (R.search || '/search') + '?q=' + encodeURIComponent(q) + '">' + (S.viewAll || 'View all results') + ' →</a></div>'
                : '<p class="muted" style="padding:10px">' + (S.noResults || 'No results') + '</p>';
            }).catch(function () { results.innerHTML = ''; });
        }, 220);
      });
    }
  }

  /* ---------- mobile drawer ---------- */
  function initDrawer() {
    var drawer = qs('[data-drawer]');
    if (!drawer || !once(drawer, 'drawer')) return;
    var opener = qs('[data-drawer-open]');
    var close = function () { drawer.hidden = true; document.documentElement.classList.remove('lock'); if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus(); } };
    on(opener, 'click', function () { drawer.hidden = false; document.documentElement.classList.add('lock'); opener.setAttribute('aria-expanded', 'true'); var f = qs('[data-drawer-close].iconbtn', drawer); if (f) f.focus(); });
    qsa('[data-drawer-close]', drawer).forEach(function (b) { on(b, 'click', close); });
    on(drawer, 'keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- sliders (hero) ---------- */
  function initSliders(root) {
    qsa('[data-slider]', root).forEach(function (slider) {
      if (!once(slider, 'slider')) return;
      var slides = qsa('[data-slide]', slider);
      var dots = qsa('[data-dot]', slider);
      if (slides.length < 2) return;
      var cur = 0, timer = null, paused = false;
      var auto = slider.getAttribute('data-autoplay') === 'true' && motion;
      var interval = parseInt(slider.getAttribute('data-interval'), 10) || 6000;
      function go(i) {
        var n = slides.length;
        i = (i + n) % n;
        if (i === cur) return;
        slides[cur].classList.remove('is-active');
        slides[cur].classList.add('is-leaving');
        slides[cur].setAttribute('aria-hidden', 'true');
        var prev = slides[cur];
        setTimeout(function () { prev.classList.remove('is-leaving'); }, 900);
        cur = i;
        slides[cur].classList.add('is-active');
        slides[cur].removeAttribute('aria-hidden');
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === cur); if (k === cur) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      }
      function play() { stop(); if (auto && !paused) timer = setInterval(function () { go(cur + 1); }, interval); }
      function stop() { clearInterval(timer); }
      on(qs('[data-prev]', slider), 'click', function () { go(cur - 1); play(); });
      on(qs('[data-next]', slider), 'click', function () { go(cur + 1); play(); });
      dots.forEach(function (d) { on(d, 'click', function () { go(parseInt(d.getAttribute('data-dot'), 10)); play(); }); });
      on(slider, 'mouseenter', function () { paused = true; stop(); });
      on(slider, 'mouseleave', function () { paused = false; play(); });
      on(slider, 'focusin', function () { paused = true; stop(); });
      on(slider, 'focusout', function () { paused = false; play(); });
      on(slider, 'keydown', function (e) { if (e.key === 'ArrowLeft') { go(cur - 1); play(); } if (e.key === 'ArrowRight') { go(cur + 1); play(); } });
      var sx = null, sy = null;
      on(slider, 'touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      on(slider, 'touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) { go(cur + (dx < 0 ? 1 : -1)); play(); }
        sx = null;
      }, { passive: true });
      on(document, 'visibilitychange', function () { if (document.hidden) stop(); else play(); });
      slider._go = function (i) { paused = true; stop(); go(i); };
      play();
    });
  }

  /* ---------- reviews pager ---------- */
  function initPager(root) {
    qsa('[data-pager]', root).forEach(function (pager) {
      if (!once(pager, 'pager')) return;
      var sec = pager.parentElement;
      var ctrls = qs('[data-pager-controls]', sec);
      if (!ctrls) return;
      var items = qsa('[data-page]', pager);
      var pages = Math.max.apply(null, items.map(function (i) { return +i.getAttribute('data-page'); })) + 1;
      var cur = 0;
      var dots = qsa('[data-pager-dot]', ctrls);
      function go(p) {
        cur = (p + pages) % pages;
        items.forEach(function (i) {
          var show = +i.getAttribute('data-page') === cur;
          i.hidden = !show;
          if (show && motion) { i.classList.remove('is-entering'); void i.offsetWidth; i.classList.add('is-entering'); }
        });
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === cur); });
      }
      on(qs('[data-pager-prev]', ctrls), 'click', function () { go(cur - 1); });
      on(qs('[data-pager-next]', ctrls), 'click', function () { go(cur + 1); });
      dots.forEach(function (d) { on(d, 'click', function () { go(+d.getAttribute('data-pager-dot')); }); });
    });
  }

  /* ---------- accordions (exclusive, animated) ---------- */
  function initAccordions(root) {
    qsa('details[data-acc]', root).forEach(function (d) {
      if (!once(d, 'acc')) return;
      var sum = qs('summary', d), body = qs('.faq__a', d);
      on(sum, 'click', function (e) {
        e.preventDefault();
        var name = d.getAttribute('name');
        var opening = !d.open;
        if (opening && name) {
          qsa('details[data-acc][name="' + name + '"][open]').forEach(function (o) { if (o !== d) collapse(o); });
        }
        if (opening) expand(d); else collapse(d);
      });
      function expand(el) {
        var b = qs('.faq__a', el);
        el.open = true;
        if (!motion || !b) return;
        var h = b.scrollHeight;
        b.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 320, easing: 'cubic-bezier(.22,1,.36,1)' });
      }
      function collapse(el) {
        var b = qs('.faq__a', el);
        if (!motion || !b) { el.open = false; return; }
        var a = b.animate([{ height: b.scrollHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 240, easing: 'ease' });
        a.onfinish = function () { el.open = false; };
      }
      void body;
    });
  }

  /* ---------- tabs ---------- */
  function initTabs(root) {
    qsa('[data-tabs]', root).forEach(function (wrap) {
      if (!once(wrap, 'tabs')) return;
      var btns = qsa('[data-tab]', wrap);
      btns.forEach(function (b) {
        on(b, 'click', function () {
          var id = b.getAttribute('data-tab');
          btns.forEach(function (x) { var onx = x === b; x.classList.toggle('is-on', onx); x.setAttribute('aria-selected', onx); });
          qsa('[data-panel]', wrap).forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== id; });
        });
      });
    });
  }

  /* ---------- quantity steppers ---------- */
  function initQty(root) {
    qsa('[data-qty]', root).forEach(function (q) {
      if (!once(q, 'qty')) return;
      var input = qs('input', q);
      qsa('[data-step]', q).forEach(function (b) {
        on(b, 'click', function () {
          var min = q.hasAttribute('data-cart-qty') ? 0 : 1;
          var v = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-step'), 10));
          input.value = v;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- product form: variants ---------- */
  function initProductForms(root) {
    qsa('[data-product-form]', root).forEach(function (form) {
      if (!once(form, 'pf')) return;
      var data = qs('[data-variants]', form);
      if (!data) return;
      var variants = [];
      try { variants = JSON.parse(data.textContent); } catch (e) { return; }
      var colourMap = {};
      var cm = qs('[data-colour-map]', form);
      if (cm) { try { colourMap = JSON.parse(cm.textContent); } catch (e) {} }
      var scope = form.closest('[data-product]') || document;
      var groups = qsa('[data-option]', form);
      var idInput = qs('[data-variant-id]', form) || qs('input[name="id"]', form);
      var addBtn = qs('[data-add]', form);

      function selected() { return groups.map(function (g) { var c = qs('input:checked', g); return c ? c.value : null; }); }
      function find(opts) { return variants.filter(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); })[0]; }

      function markAvailability(opts) {
        groups.forEach(function (g, gi) {
          qsa('input', g).forEach(function (inp) {
            var test = opts.slice(); test[gi] = inp.value;
            var v = find(test);
            var lab = inp.closest('label');
            if (lab) lab.classList.toggle('is-unavailable', !v || !v.available);
          });
        });
      }

      function update() {
        var opts = selected();
        var v = find(opts);
        groups.forEach(function (g, i) { var lbl = qs('[data-option-value]', g); if (lbl) lbl.textContent = opts[i] || ''; });
        markAvailability(opts);
        var labelTarget = addBtn ? (qs('[data-add-label]', addBtn) || addBtn) : null;
        if (!v) {
          if (addBtn) { addBtn.disabled = true; labelTarget.textContent = S.unavailable || 'Unavailable'; }
          return;
        }
        if (idInput) idInput.value = v.id;
        var price = qs('[data-price]', scope), was = qs('[data-was]', scope);
        if (price) price.textContent = formatMoney(v.price);
        if (was) { if (v.compare > v.price) { was.textContent = formatMoney(v.compare); was.hidden = false; } else { was.textContent = ''; was.hidden = true; } }
        qsa('[data-stock]', scope).forEach(function (st) {
          st.classList.toggle('is-out', !v.available);
          st.textContent = (st.classList.contains('pill') ? '' : '● ') + (v.available ? (S.inStock || 'In stock') : (S.soldOut || 'Sold out'));
        });
        if (addBtn) { addBtn.disabled = !v.available; labelTarget.textContent = v.available ? (S.addToCart || 'Add to cart') : (S.soldOut || 'Sold out'); }
        var img = qs('[data-main-img]', scope);
        if (img && v.img) swapImage(img, v.img);
        if (v.media) qsa('.pdp__thumb', scope).forEach(function (t) { t.classList.toggle('is-on', +t.getAttribute('data-media-id') === v.media); });
        var art = qs('[data-art]', scope);
        if (art) {
          var colourGroup = groups.filter(function (g) { return qs('.swatches', g); })[0];
          var chk = colourGroup && qs('input:checked', colourGroup);
          if (chk) art.style.setProperty('--art', chk.getAttribute('data-hex') || colourMap[(chk.value || '').toLowerCase()] || '');
        }
        qsa('[data-spec-option]', scope).forEach(function (dd) {
          var key = dd.getAttribute('data-spec-option');
          groups.forEach(function (g, i) {
            var legend = (qs('.opt__label', g) || {}).textContent || '';
            if (legend.toLowerCase().indexOf(key) > -1) dd.textContent = opts[i];
          });
        });
        if (form.closest('.pdp') && window.history && history.replaceState) {
          history.replaceState(null, '', withParam(window.location.href, 'variant', v.id));
        }
      }

      groups.forEach(function (g) { qsa('input', g).forEach(function (i) { on(i, 'change', update); }); });
      markAvailability(selected());
    });
  }
  function swapImage(img, src) {
    if (img.getAttribute('src') === src) return;
    img.classList.add('is-swapping');
    var pre = new Image();
    pre.onload = function () { img.removeAttribute('srcset'); img.src = src; img.classList.remove('is-swapping'); };
    pre.src = src;
  }

  /* ---------- gallery thumbs ---------- */
  function initGallery(root) {
    qsa('[data-gallery]', root).forEach(function (g) {
      if (!once(g, 'gal')) return;
      var main = qs('[data-main-img]', g);
      qsa('.pdp__thumb[data-thumb]', g).forEach(function (t) {
        on(t, 'click', function () {
          qsa('.pdp__thumb', g).forEach(function (x) { x.classList.toggle('is-on', x === t); });
          if (main) swapImage(main, t.getAttribute('data-thumb'));
        });
      });
    });
  }

  /* ---------- AJAX add to cart ---------- */
  function initAjaxCart() {
    if (!once(document, 'ajax')) return;
    on(document, 'submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form[data-ajax-cart]')) return;
      e.preventDefault();
      var btn = qs('[type="submit"]', form);
      if (btn) btn.classList.add('is-loading');
      var err = qs('[data-form-error]', form);
      if (err) err.hidden = true;
      fetch((R.cartAdd || '/cart/add') + '.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (item) {
          return refreshCount().then(function (cart) {
            var name = (btn && btn.getAttribute('data-add-name')) || item.product_title || '';
            var scope = form.closest('[data-product]');
            var added = scope && qs('[data-added]', scope);
            if (added && !form.hasAttribute('data-close-modal')) {
              var c = qs('[data-added-count]', added);
              if (c) c.textContent = cart.item_count;
              added.hidden = false;
            } else {
              toast(item.variant_title && item.variant_title !== 'Default Title' ? name + ' – ' + item.variant_title : name);
            }
            if (form.hasAttribute('data-close-modal')) closeQuick();
            if (form.hasAttribute('data-refresh-cart') || document.querySelector('[data-cart-section]')) refreshCartSection();
          });
        })
        .catch(function (j) {
          var msg = (j && (j.description || j.message)) || S.error;
          if (err) { err.textContent = msg; err.hidden = false; } else toast(msg, true);
        })
        .then(function () { if (btn) btn.classList.remove('is-loading'); });
    });
  }

  /* ---------- quick view ---------- */
  var quickModal, lastFocus;
  function closeQuick() {
    if (!quickModal || quickModal.hidden) return;
    quickModal.hidden = true;
    document.documentElement.classList.remove('lock');
    if (lastFocus) lastFocus.focus();
  }
  function initQuick() {
    quickModal = qs('[data-quick-modal]');
    if (!quickModal || !once(document, 'quick')) return;
    var body = qs('[data-quick-body]', quickModal);
    on(document, 'click', function (e) {
      var t = e.target.closest('[data-quick]');
      if (t) {
        e.preventDefault();
        lastFocus = t;
        var url = t.getAttribute('data-quick');
        body.innerHTML = '<div class="spinner" role="progressbar"></div>';
        body.classList.add('is-loading');
        quickModal.hidden = false;
        document.documentElement.classList.add('lock');
        fetchHTML(withParam(url, 'section_id', 'quick-view')).then(function (doc) {
          var qv = qs('.qv', doc);
          if (!qv) { window.location.href = url; return; }
          body.classList.remove('is-loading');
          body.innerHTML = '';
          body.appendChild(qv);
          initProductForms(body);
          var f = qs('[data-quick-close]', body) || qs('button', body);
          if (f) f.focus();
        }).catch(function () { window.location.href = url; });
        return;
      }
      if (e.target.closest('[data-quick-close]')) closeQuick();
    });
    on(document, 'keydown', function (e) { if (e.key === 'Escape') closeQuick(); });
    on(quickModal, 'keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = qsa('a[href], button:not([disabled]), input:not([type="hidden"]), select', body).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
  }

  /* ---------- collection filters & sort ---------- */
  function initCollection(root) {
    qsa('[data-collection]', root).forEach(function (coll) {
      if (!once(coll, 'coll')) return;
      var section = coll.closest('[id^="shopify-section-"]');
      var sectionId = section ? section.id.replace('shopify-section-', '') : null;
      var form = qs('[data-filter-form]', coll);
      var sort = qs('[data-sort]', coll);
      function load(url) {
        if (!sectionId) { window.location.href = url; return; }
        coll.classList.add('is-loading');
        fetchHTML(withParam(url, 'section_id', sectionId)).then(function (doc) {
          var fresh = qs('[data-collection]', doc);
          if (!fresh) { window.location.href = url; return; }
          coll.replaceWith(fresh);
          history.pushState({ vcColl: true }, '', url);
          initAll(fresh.parentElement);
          qsa('.rv', fresh).forEach(function (el) { el.classList.add('in'); });
        }).catch(function () { window.location.href = url; });
      }
      function urlFromForm() {
        var fd = new FormData(form);
        var params = new URLSearchParams();
        fd.forEach(function (v, k) { if (v !== '') params.append(k, v); });
        if (sort) params.set('sort_by', sort.value);
        return form.getAttribute('action') + '?' + params.toString();
      }
      if (form) {
        var t;
        on(form, 'change', function () { clearTimeout(t); t = setTimeout(function () { load(urlFromForm()); }, 250); });
        on(form, 'submit', function (e) { e.preventDefault(); load(urlFromForm()); });
      }
      on(sort, 'change', function () { if (form) load(urlFromForm()); else window.location.href = withParam(window.location.href, 'sort_by', sort.value); });
      /* mobile filters drawer */
      var panel = qs('[data-filters]', coll);
      var backdrop;
      function closeF() { if (!panel) return; panel.classList.remove('is-open'); document.documentElement.classList.remove('lock'); if (backdrop) { backdrop.remove(); backdrop = null; } }
      on(qs('[data-filters-open]', coll), 'click', function () {
        panel.classList.add('is-open');
        document.documentElement.classList.add('lock');
        backdrop = document.createElement('div');
        backdrop.className = 'filters-backdrop';
        on(backdrop, 'click', closeF);
        document.body.appendChild(backdrop);
      });
      on(qs('[data-filters-close]', coll), 'click', closeF);
    });
    if (once(window, 'popcoll')) on(window, 'popstate', function (e) { if (e.state && e.state.vcColl) window.location.reload(); });
  }

  /* ---------- cart page ---------- */
  function cartSectionEl() { return qs('[data-cart-section]'); }
  function refreshCartSection() {
    var el = cartSectionEl();
    if (!el) return Promise.resolve();
    var id = el.getAttribute('data-cart-section');
    el.classList.add('is-loading');
    return fetchHTML((R.cart || '/cart') + '?section_id=' + id).then(function (doc) {
      var fresh = qs('[data-cart-section]', doc);
      if (fresh) { el.replaceWith(fresh); initAll(fresh.parentElement); qsa('.rv', fresh).forEach(function (x) { x.classList.add('in'); }); }
      return refreshCount();
    }).catch(function () { window.location.reload(); });
  }
  function initCart(root) {
    var el = qs('[data-cart-section]', root) || (root === document ? cartSectionEl() : null);
    if (!el || !once(el, 'cart')) return;
    /* keep the cart attribute "Order type" (Wholesale / Retail) in sync for checkout shipping rules */
    var wantType = el.getAttribute('data-order-type');
    if (wantType && wantType !== el.getAttribute('data-order-attr')) {
      postJSON((R.cartUpdate || '/cart/update') + '.js', { attributes: { 'Order type': wantType } }).then(function () {
        el.setAttribute('data-order-attr', wantType);
      }).catch(function () {});
    }
    /* quantity */
    qsa('[data-cart-qty]', el).forEach(function (q) {
      var line = +q.getAttribute('data-cart-qty');
      var input = qs('input', q);
      var t;
      on(input, 'change', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          el.classList.add('is-loading');
          postJSON((R.cartChange || '/cart/change') + '.js', { line: line, quantity: Math.max(0, parseInt(input.value, 10) || 0) })
            .then(refreshCartSection)
            .catch(function (j) { toast((j && j.description) || S.error, true); refreshCartSection(); });
        }, 300);
      });
    });
    qsa('[data-remove]', el).forEach(function (a) {
      on(a, 'click', function (e) {
        e.preventDefault();
        el.classList.add('is-loading');
        postJSON((R.cartChange || '/cart/change') + '.js', { line: +a.getAttribute('data-remove'), quantity: 0 }).then(refreshCartSection);
      });
    });
    /* gift + note → cart attributes */
    qsa('[data-cart-attr]', el).forEach(function (c) {
      on(c, 'change', function () { var a = {}; a[c.name.replace('attributes[', '').replace(']', '')] = c.checked ? 'Yes' : 'No'; postJSON((R.cartUpdate || '/cart/update') + '.js', { attributes: a }); });
    });
    var note = qs('[data-cart-note]', el), nt;
    on(note, 'input', function () { clearTimeout(nt); nt = setTimeout(function () { postJSON((R.cartUpdate || '/cart/update') + '.js', { note: note.value }); }, 500); });
    /* discount codes */
    var dform = qs('[data-discount-form]');
    var dinput = qs('[data-discount-input]', el);
    function currentCodes() { return qsa('[data-discount-remove]', el).map(function (b) { return b.getAttribute('data-discount-remove'); }); }
    function applyCodes(codes) {
      el.classList.add('is-loading');
      return postJSON((R.cartUpdate || '/cart/update') + '.js', { discount: codes.join(',') }).then(refreshCartSection).catch(function () { refreshCartSection(); });
    }
    if (dform && dinput) {
      on(dform, 'submit', function (e) {
        e.preventDefault();
        var code = dinput.value.trim();
        if (!code) { dinput.focus(); return; }
        var codes = currentCodes();
        if (codes.indexOf(code) === -1) codes.push(code);
        applyCodes(codes);
      });
      on(dinput, 'keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); dform.requestSubmit ? dform.requestSubmit() : dform.dispatchEvent(new Event('submit', { cancelable: true })); } });
    }
    qsa('[data-discount-remove]', el).forEach(function (b) {
      on(b, 'click', function () { var code = b.getAttribute('data-discount-remove'); applyCodes(currentCodes().filter(function (c) { return c !== code; })); });
    });
    /* free-shipping meter in the shopper's currency */
    var meter = qs('[data-shipmeter]', el);
    var rate = window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate);
    if (meter && rate && rate !== 1) {
      var threshold = Math.round(parseInt(meter.getAttribute('data-threshold'), 10) * rate);
      var total = parseInt(meter.getAttribute('data-total'), 10);
      var left = threshold - total;
      var txt = qs('[data-shipmeter-text]', meter);
      if (txt) txt.innerHTML = left > 0 ? meter.getAttribute('data-msg-left').replace('[amount]', formatMoney(left)) : meter.getAttribute('data-msg-done');
      var bar = qs('.shipmeter__bar span', meter);
      if (bar) bar.style.width = Math.min(100, Math.round(total / threshold * 100)) + '%';
    }
  }

  /* ---------- small UI ---------- */
  function initMisc(root) {
    qsa('[data-pw]', root).forEach(function (w) {
      if (!once(w, 'pw')) return;
      var input = qs('input', w), btn = qs('[data-pw-toggle]', w);
      on(btn, 'click', function () { var show = input.type === 'password'; input.type = show ? 'text' : 'password'; btn.textContent = show ? (S.hide || 'Hide') : (S.show || 'Show'); });
    });
    qsa('[data-countdown]', root).forEach(function (el) {
      if (!once(el, 'cd')) return;
      var end = new Date(el.getAttribute('data-countdown')).getTime();
      if (isNaN(end)) { el.hidden = true; return; }
      var d = qs('[data-d]', el), h = qs('[data-h]', el), m = qs('[data-m]', el);
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var left = Math.max(0, end - Date.now());
        if (!left) { el.hidden = true; return; }
        d.textContent = pad(Math.floor(left / 864e5));
        h.textContent = pad(Math.floor(left % 864e5 / 36e5));
        m.textContent = pad(Math.floor(left % 36e5 / 6e4));
      }
      tick(); setInterval(tick, 30000);
    });
    qsa('[data-auth]', root).forEach(function (a) {
      if (!once(a, 'auth')) return;
      var tabs = qs('[data-auth-tabs]', a);
      function go(mode) {
        qsa('[data-auth-panel]', a).forEach(function (p) { p.hidden = p.getAttribute('data-auth-panel') !== mode; });
        if (tabs) {
          tabs.hidden = !(mode === 'signin' || mode === 'create');
          qsa('[data-auth-go]', tabs).forEach(function (b) { var onb = b.getAttribute('data-auth-go') === mode; b.classList.toggle('is-on', onb); b.setAttribute('aria-selected', onb); });
        }
      }
      qsa('[data-auth-go]', a).forEach(function (b) { on(b, 'click', function () { go(b.getAttribute('data-auth-go')); }); });
      if (window.location.hash === '#recover') go('reset');
      /* show the panel that holds a form error */
      var errPanel = qsa('[data-auth-panel]', a).filter(function (p) { return qs('.form-err', p); })[0];
      if (errPanel) go(errPanel.getAttribute('data-auth-panel'));
    });
    qsa('[data-toggle-target]', root).forEach(function (b) {
      if (!once(b, 'tgl')) return;
      on(b, 'click', function () { var t = document.getElementById(b.getAttribute('data-toggle-target')); if (t) t.hidden = !t.hidden; });
    });
    qsa('form[data-confirm]', root).forEach(function (f) {
      if (!once(f, 'cf')) return;
      on(f, 'submit', function (e) { if (!window.confirm(f.getAttribute('data-confirm'))) e.preventDefault(); });
    });
    qsa('select[data-default]', root).forEach(function (s) { var v = s.getAttribute('data-default'); if (v) s.value = v; });
    qsa('[data-track-form]', root).forEach(function (f) {
      if (!once(f, 'trk')) return;
      on(f, 'submit', function (e) {
        e.preventDefault();
        var tpl = f.getAttribute('data-template');
        var order = encodeURIComponent((f.order.value || '').replace('#', '').trim());
        var email = encodeURIComponent((f.email.value || '').trim());
        window.location.href = tpl.indexOf('{order}') > -1 ? tpl.replace('{order}', order).replace('{email}', email) : tpl + (tpl.indexOf('?') > -1 ? '&' : '?') + 'order=' + order + '&email=' + email;
      });
    });
    qsa('[data-load-more]', root).forEach(function (a) {
      if (!once(a, 'lm')) return;
      on(a, 'click', function (e) {
        e.preventDefault();
        a.classList.add('is-loading');
        fetchHTML(a.href).then(function (doc) {
          var list = qs('[data-load-list]'), more = qs('[data-load-list]', doc);
          if (list && more) qsa('.post', more).forEach(function (p) { list.appendChild(p); p.classList.add('rv'); requestAnimationFrame(function () { p.classList.add('in'); }); });
          var next = qs('[data-load-more]', doc);
          if (next) { a.href = next.href; a.classList.remove('is-loading'); } else a.closest('.sec__cta').remove();
          initTilt(list);
        }).catch(function () { window.location.href = a.href; });
      });
    });
    qsa('[data-recs]', root).forEach(function (el) {
      if (!once(el, 'recs')) return;
      fetchHTML(el.getAttribute('data-recs')).then(function (doc) {
        var fresh = qs('[data-recs]', doc);
        if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; initAll(el); qsa('.rv', el).forEach(function (x) { x.classList.add('in'); }); }
      }).catch(function () {});
    });
  }

  /* ---------- languages (shared by entry page + header) ---------- */
  var COUNTRY_LANG = { ES: 'es', PT: 'pt', FR: 'fr', DE: 'de', AT: 'de', CH: 'de', LI: 'de', IT: 'it', SM: 'it', NL: 'nl', BE: 'nl', LU: 'fr', MC: 'fr', IE: 'en', GB: 'en', PL: 'pl', CZ: 'cs', SK: 'sk', SI: 'sl', HR: 'hr', RS: 'sr', ME: 'sr', BA: 'bs', HU: 'hu', RO: 'ro', MD: 'ro', BG: 'bg', GR: 'el', CY: 'el', SE: 'sv', DK: 'da', NO: 'no', FI: 'fi', EE: 'et', LV: 'lv', LT: 'lt', MT: 'mt', IS: 'is', AL: 'sq', MK: 'mk', UA: 'uk', AD: 'ca' };
  function pageLang() { return (document.documentElement.getAttribute('lang') || 'en').slice(0, 2).toLowerCase(); }
  function googleLang() { var m = document.cookie.match(/(?:^|;\s*)googtrans=\/[^\/]*\/([^;]+)/); return m ? decodeURIComponent(m[1]) : ''; }
  function setGoogle(code, autoSource) {
    var host = location.hostname.replace(/^www\./, '');
    var val = code ? '/' + (autoSource ? 'auto' : pageLang()) + '/' + code : '';
    var exp = code ? '' : '; expires=Thu, 01 Jan 1970 00:00:00 GMT';
    document.cookie = 'googtrans=' + val + '; path=/' + exp;
    document.cookie = 'googtrans=' + val + '; path=/; domain=.' + host + exp;
    document.cookie = 'googtrans=' + val + '; path=/; domain=' + location.hostname + exp;
  }
  function currentLang() { return googleLang() || pageLang(); }
  /* Mark the language that is really showing (native or Google) in every list */
  function markLanguages() {
    var cur = currentLang();
    qsa('[data-lang-pick]').forEach(function (b) {
      var onb = b.getAttribute('data-lang-pick') === cur;
      b.classList.toggle('is-on', onb);
      if (b.hasAttribute('aria-checked')) b.setAttribute('aria-checked', onb);
    });
    qsa('[data-lang-current]').forEach(function (el) { el.textContent = cur.toUpperCase(); });
    qsa('[data-gate-lang]').forEach(function (sel) { if (qs('option[value="' + cur + '"]', sel)) sel.value = cur; });
  }
  /* Header / drawer language buttons */
  function initLanguagePicks() {
    if (!once(document, 'langpick')) return;
    markLanguages();
    on(document, 'click', function (e) {
      var b = e.target.closest('[data-lang-pick]');
      if (!b || b.closest('[data-gate]')) return;
      var code = b.getAttribute('data-lang-pick'), native = b.getAttribute('data-native');
      if (native) {
        /* Shopify language: clear any Google translation, let the localization form submit */
        var had = !!googleLang();
        if (had) setGoogle('');
        if (native.slice(0, 2).toLowerCase() === pageLang()) { e.preventDefault(); if (had) location.reload(); }
        return;
      }
      e.preventDefault();
      if (code === pageLang()) setGoogle(''); else setGoogle(code);
      location.reload();
    });
  }

  /* ---------- entry gate ---------- */
  function initGate() {
    var g = qs('[data-gate]');
    if (!g || !once(g, 'gate')) return;
    var form = qs('[data-gate-form]', g);
    var yes = qs('[data-gate-yes]', g), no = qs('[data-gate-no]', g);
    var enter = qs('[data-gate-enter]', g);
    var denied = qs('[data-gate-denied]', g);
    var country = qs('[data-gate-country]', g), lang = qs('[data-gate-lang]', g);
    var langInput = qs('[data-gate-lang-input]', g);
    var remember = qs('[data-gate-remember]', g);
    var blocked = (g.getAttribute('data-blocked') || '').split(',').filter(Boolean);
    var curLang = g.getAttribute('data-current-lang') || 'en', curCountry = g.getAttribute('data-current-country');
    var design = g.getAttribute('data-design') === 'true';
    var ageOk = false;

    function setGate(v, days) { document.cookie = 'vc_gate=' + v + '; path=/; SameSite=Lax' + (days ? '; max-age=' + days * 86400 : ''); }
    function lockPage(lock) {
      document.documentElement.classList.toggle('gate-open', lock);
      [qs('#main')].concat(qsa('.shopify-section-group-header-group, .shopify-section-group-footer-group')).forEach(function (el) {
        if (!el) return; if (lock) el.setAttribute('inert', ''); else el.removeAttribute('inert');
      });
    }
    function show() { g.hidden = false; lockPage(true); setTimeout(function () { g.focus({ preventScroll: true }); }, 60); }
    function hide() {
      g.classList.add('is-leaving');
      setTimeout(function () { g.hidden = true; g.classList.remove('is-leaving'); lockPage(false); }, motion ? 450 : 0);
    }
    function refresh() {
      var ready = ageOk && (!country || !!country.value);
      enter.disabled = !ready;
      qs('[data-enter-on]', enter).hidden = !ready;
      qs('[data-enter-off]', enter).hidden = ready;
    }
    function deny(reason) {
      form.hidden = true; denied.hidden = false;
      var c = reason === 'country';
      qs('[data-deny-body]', denied).hidden = c;
      qs('[data-deny-country]', denied).hidden = !c;
      if (!c) setGate('no');
      var back = qs('[data-gate-back]', denied); if (back) back.focus();
    }

    on(yes, 'click', function () { ageOk = true; yes.setAttribute('aria-pressed', 'true'); refresh(); });
    on(no, 'click', function () { ageOk = false; yes.setAttribute('aria-pressed', 'false'); refresh(); deny('age'); });
    on(country, 'change', function () {
      refresh();
      if (lang && g.getAttribute('data-auto-lang') === 'true') {
        var l = COUNTRY_LANG[(country.value || '').toUpperCase()];
        if (l && qs('option[value="' + l + '"]', lang)) lang.value = l;
      }
    });
    on(qs('[data-gate-back]', g), 'click', function () {
      document.cookie = 'vc_gate=; path=/; max-age=0; SameSite=Lax';
      denied.hidden = true; form.hidden = false; ageOk = false; yes.setAttribute('aria-pressed', 'false'); refresh(); yes.focus();
    });

    on(form, 'submit', function (e) {
      if (!ageOk || (country && !country.value)) { e.preventDefault(); g.classList.remove('is-shake'); void g.offsetWidth; g.classList.add('is-shake'); return; }
      var cc = country ? country.value : '';
      if (cc && blocked.indexOf(cc.toUpperCase()) > -1) { e.preventDefault(); deny('country'); return; }

      var days = remember && remember.checked ? (parseInt(g.getAttribute('data-days'), 10) || 30) : 0;
      setGate('ok', days);
      try {
        localStorage.setItem('vc-gate-choice', JSON.stringify({ country: cc, language: lang ? lang.value : '', at: Date.now() }));
        if (days) localStorage.setItem('vc-gate-until', String(Date.now() + days * 864e5)); else localStorage.removeItem('vc-gate-until');
      } catch (err) {}

      var opt = lang && lang.options[lang.selectedIndex];
      var code = opt ? opt.value : curLang.slice(0, 2);
      var native = opt ? opt.getAttribute('data-native') : curLang;
      var cOpt = country && country.options[country.selectedIndex];
      var isMarket = cOpt && cOpt.getAttribute('data-market') === 'true';
      document.dispatchEvent(new CustomEvent('vapercore:localization', { detail: { country: cc, language: code } }));
      if (design) { e.preventDefault(); hide(); return; }

      /* Send the country only when it really changes the market — like the header menu.
         Posting the same country again makes Shopify re-pick the market's default language. */
      var countryChanged = !!(isMarket && cc && cc !== curCountry);
      if (country && !countryChanged) country.removeAttribute('name');

      /* Is the chosen language switched on in the chosen country's market? (Settings › Markets › Languages) */
      var short = function (l) { return String(l || '').slice(0, 2).toLowerCase(); };
      var marketLangs = countryChanged && cOpt.getAttribute('data-langs') ? cOpt.getAttribute('data-langs').split(',') : null;
      var nativeOk = !!native && (!marketLangs || marketLangs.some(function (l) { return short(l) === short(native); }));
      if (nativeOk && marketLangs) {
        marketLangs.forEach(function (l) { if (short(l) === short(native)) native = l; });
      }

      var after = g.getAttribute('data-after') || 'home';
      var home = g.getAttribute('data-home') || '/';
      var onHome = g.getAttribute('data-page') === 'index';
      /* No form post needed: go home (or just close the gate) */
      function finish(reload) {
        if (after === 'home' && !onHome) { window.location.href = home; return; }
        if (reload) { window.location.reload(); return; }
        hide();
      }

      /* Only the gate's own return address is sent (the form tag adds the current page by default) */
      var ret = qs('[data-gate-return]', form);
      if (ret) qsa('input[name="return_to"]', form).forEach(function (i) { if (i !== ret) i.removeAttribute('name'); });

      var hadGoogle = !!googleLang();
      if (nativeOk) {
        /* Published Shopify language (Translate & Adapt etc.): the store reloads in it, header included */
        if (hadGoogle) setGoogle('');
        var langChanged = native !== curLang;
        if (langChanged) langInput.value = native; else langInput.removeAttribute('name');
        if (!langChanged && !countryChanged) { e.preventDefault(); finish(hadGoogle); return; }
        enter.classList.add('is-busy');
        return; /* localization form posts and returns to the home page in the new language */
      }
      /* Language not available in Shopify for this market: translate instantly with Google's website translator */
      langInput.removeAttribute('name');
      var wantGoogle = short(code) !== pageLang() || countryChanged;
      setGoogle(wantGoogle ? code : '', countryChanged);
      enter.classList.add('is-busy');
      if (countryChanged) return; /* localization form posts (new currency) and the translation applies on arrival */
      e.preventDefault();
      finish(true);
    });

    on(g, 'keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = qsa('a[href], button:not([disabled]), select, input:not([type="hidden"])', g).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });

    markLanguages();
    if (!g.hidden) {
      lockPage(true);
      if (g.getAttribute('data-start-denied') === 'true') deny('age');
      else setTimeout(function () { g.focus({ preventScroll: true }); }, 80);
    }
    refresh();

    if (design) {
      on(document, 'shopify:section:select', function (e) { if (e.target.contains(g) || e.target.id.indexOf('entry-gate') > -1) show(); });
      on(document, 'shopify:section:deselect', function (e) { if (e.target.contains(g) || e.target.id.indexOf('entry-gate') > -1) { g.hidden = true; lockPage(false); } });
    }
  }

  /* ---------- creative effects ---------- */
  function initProgress() {
    var bar = qs('[data-progress]');
    if (!bar || !once(bar, 'prog')) return;
    var t = false;
    function upd() { var h = document.documentElement.scrollHeight - window.innerHeight; bar.style.transform = 'scaleX(' + (h > 0 ? Math.min(1, window.scrollY / h) : 0) + ')'; t = false; }
    on(window, 'scroll', function () { if (!t) { t = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
  }
  /* split section headings into words for the word-by-word reveal */
  function initWords(root) {
    if (!motion) return;
    qsa('.shead__h', root).forEach(function (h) {
      if (!once(h, 'words')) return;
      var i = 0;
      Array.prototype.slice.call(h.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
            var s = document.createElement('span'); s.className = 'w'; s.textContent = part; s.style.setProperty('--wi', i++); frag.appendChild(s);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1) { n.style.setProperty('--wi', i++); }
      });
    });
  }
  /* soft glow that follows the cursor on cards */
  function initGlow(root) {
    if (!finePointer) return;
    qsa('.pcard, .trust__card, .step, .stcard', root).forEach(function (c) {
      if (!once(c, 'glow')) return;
      on(c, 'pointermove', function (e) { var r = c.getBoundingClientRect(); c.style.setProperty('--mx', (e.clientX - r.left) + 'px'); c.style.setProperty('--my', (e.clientY - r.top) + 'px'); });
    });
  }
  /* drag-to-rotate 3D device */
  function initD3(root) {
    qsa('[data-d3]', root).forEach(function (d) {
      if (!once(d, 'd3')) return;
      var obj = qs('[data-d3-obj]', d), ry = -24, startX = null, base = 0, idle;
      function set() { obj.style.transform = 'rotateX(-6deg) rotateY(' + ry + 'deg)'; }
      on(d, 'pointerdown', function (e) {
        var cur = getComputedStyle(obj).transform;
        if (cur && cur !== 'none') { try { var m = new DOMMatrix(cur); ry = Math.atan2(-m.m13, m.m11) * 180 / Math.PI; } catch (err) {} }
        d.classList.add('is-user', 'is-drag'); set();
        startX = e.clientX; base = ry; clearTimeout(idle);
        try { d.setPointerCapture(e.pointerId); } catch (err) {}
      });
      on(d, 'pointermove', function (e) { if (startX === null) return; ry = base + (e.clientX - startX) * 0.6; set(); });
      function end() { if (startX === null) return; startX = null; d.classList.remove('is-drag'); idle = setTimeout(function () { d.classList.remove('is-user'); obj.style.transform = ''; }, 4000); }
      on(d, 'pointerup', end); on(d, 'pointercancel', end);
    });
  }
  /* count-up numbers (wholesale stats) */
  function initCount(root) {
    if (!motion || !('IntersectionObserver' in window)) return;
    qsa('[data-count]', root).forEach(function (el) {
      if (!once(el, 'count')) return;
      var txt = el.textContent.trim(), m = txt.match(/^(\D*)(\d[\d.,]*)(.*)$/);
      if (!m) return;
      var target = parseFloat(m[2].replace(/[.,](?=\d{3}\b)/g, '').replace(',', '.'));
      if (isNaN(target)) return;
      var io = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return; io.disconnect();
        var t0 = performance.now(), dur = 1400;
        (function step(t) {
          var p = Math.min(1, (t - t0) / dur), v = target * (1 - Math.pow(1 - p, 3));
          el.textContent = m[1] + (target % 1 ? v.toFixed(1) : Math.round(v)) + m[3];
          if (p < 1) requestAnimationFrame(step); else el.textContent = txt;
        })(t0);
      }, { threshold: 0.4 });
      io.observe(el);
    });
  }

  /* ---------- boot ---------- */
  function initAll(root) {
    root = root || document;
    safe('words', function () { initWords(root); });
    safe('reveal', function () { initReveal(root); });
    safe('tilt', function () { initTilt(root); });
    safe('parallax', function () { initParallax(root); });
    safe('header', function () { initHeader(root); });
    safe('sliders', function () { initSliders(root); });
    safe('pager', function () { initPager(root); });
    safe('accordions', function () { initAccordions(root); });
    safe('tabs', function () { initTabs(root); });
    safe('qty', function () { initQty(root); });
    safe('productForms', function () { initProductForms(root); });
    safe('gallery', function () { initGallery(root); });
    safe('collection', function () { initCollection(root); });
    safe('cart', function () { initCart(root); });
    safe('misc', function () { initMisc(root); });
    safe('glow', function () { initGlow(root); });
    safe('d3', function () { initD3(root); });
    safe('count', function () { initCount(root); });
  }

  function boot() {
    safe('drawer', initDrawer);
    safe('ajaxCart', initAjaxCart);
    safe('quick', initQuick);
    safe('gate', initGate);
    safe('languages', initLanguagePicks);
    safe('progress', initProgress);
    initAll(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  /* theme editor */
  document.addEventListener('shopify:section:load', function (e) {
    safe('section:load', function () {
      initAll(e.target);
      if (qs('[data-gate]', e.target)) { var g = qs('[data-gate]', e.target); g._vcgate = false; initGate(); g.hidden = false; document.documentElement.classList.add('gate-open'); }
      if (qs('[data-drawer]', e.target)) initDrawer();
      qsa('.rv', e.target).forEach(function (x) { x.classList.add('in'); });
    });
  });
  document.addEventListener('shopify:block:select', function (e) {
    safe('block:select', function () {
      var slide = e.target.closest('[data-slide]');
      var slider = slide && slide.closest('[data-slider]');
      if (slider && slider._go) slider._go(qsa('[data-slide]', slider).indexOf(slide));
      var rev = e.target.closest('[data-page]');
      if (rev && rev.hidden) {
        var dot = qs('[data-pager-dot="' + rev.getAttribute('data-page') + '"]', rev.closest('.sec'));
        if (dot) dot.click();
      }
    });
  });

  window.VaperCore = { formatMoney: formatMoney, refreshCount: refreshCount, toast: toast };
})();
